<template>
  <div class="d-flex">
    <v-btn-toggle class="mx-auto mb-2 transparent" v-model="index">
      <v-btn icon>
        <v-icon>mdi-rocket-launch-outline</v-icon>
      </v-btn>
      <v-btn icon>
        <v-icon>mdi-comment-text-outline</v-icon>
      </v-btn>
    </v-btn-toggle>
  </div>
</template>

<script>

export default {
  name: "SubContentSwitcher",
  components: { },
  props: ['value'],
  data() {
    return {
      index:0,
    }
  },
  mounted() {
  },
  methods: {
  },
  computed: {
  },
  watch: {
    value(n) {
      this.index=n;
    },
    index(n) {
      this.$emit('input', n);
    }
  }
}
</script>

<style scoped>

</style>